import { render, staticRenderFns } from "./ContactPhoneNumberLabelSelect.vue?vue&type=template&id=f70d2820"
import script from "./ContactPhoneNumberLabelSelect.vue?vue&type=script&lang=js"
export * from "./ContactPhoneNumberLabelSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports